export default "__VITE_ASSET__Bln6X1ky__"